module.exports = __webpack_public_path__ + "img/illustrations-edit-profile.ef1fc56b.svg";